import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { getRequisitionFieldsFromParcelInstrument } from '@core/util/requisitions';
import { ParcelInstrument, SavedPin } from '@models/teranet';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SalePinState } from '@state/sale_pins';
import { NewRequisitionModalComponent } from '../../matter-requisition/new-requisition-modal/new-requisition-modal.component';
import { DEFAULT_REQUISITION_DIMENSIONS } from '../..';

@Component({
	selector: 'app-teranet-instruments-requisition',
	templateUrl: './teranet-instruments-requisition.component.html',
	standalone: false,
})
export class TeranetInstrumentsRequisitionComponent implements OnInit {
	@SelectSnapshot(SalePinState.getAll) pins: SavedPin[];

	public instruments: ParcelInstrument[];
	public ICON = ICON;
	public selectedInstrument: ParcelInstrument;

	public primaryPinList;
	public selectedPrimaryPin: SavedPin;
	public selectedPrimaryPinId: string;

	public adjacentPinList;
	public selectedAdjacentPin: SavedPin;
	public selectedAdjacentPinId: string;

	public showAdjacentPins = false;

	ngOnInit(): void {
		this.primaryPinList = this.getPrimaryPinList();
		if (this.primaryPinList.length) {
			this.selectedPrimaryPinId = this.primaryPinList[0].value;
			this.selectedPrimaryPin = this.pins?.find(
				(pin) => pin.pin === this.selectedPrimaryPinId,
			);
			this.instruments = this.getInstruments(this.selectedPrimaryPin);
		}

		this.adjacentPinList = this.getAdjacentPinList();
	}

	constructor(
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<TeranetInstrumentsRequisitionComponent>,
	) {}

	onRowClick(parcelInstrument: ParcelInstrument) {
		this.selectedInstrument = parcelInstrument;
	}

	getPrimaryPinList() {
		const pins = this.pins?.filter((pin) => pin.primary);
		if (pins.length) {
			return pins.map((pin) => ({ label: pin.pin, value: pin.pin }));
		}

		return [];
	}

	getAdjacentPinList() {
		const pins = this.pins?.filter((pin) => !pin.primary);
		if (pins.length) {
			return pins.map((pin) => ({ label: pin.pin, value: pin.pin }));
		}

		return [];
	}

	createRequisition() {
		if (this.selectedInstrument) {
			const fields = getRequisitionFieldsFromParcelInstrument(
				this.selectedInstrument,
			);

			this.dialog.open(NewRequisitionModalComponent, {
				...DEFAULT_REQUISITION_DIMENSIONS,
				data: { fields },
			});
		}
	}

	getInstruments(pin: SavedPin): ParcelInstrument[] {
		const tmpInstruments = [];

		pin?.parcels?.forEach((parcel) => {
			tmpInstruments.push(
				...parcel.instruments.map((instrument) => ({
					...instrument,
					pin: pin.pin,
				})),
			);
		});

		return tmpInstruments;
	}

	onSelectPrimarySearchItem(selectedPinId: string) {
		this.selectedPrimaryPin = this.pins?.find(
			(pin) => pin.pin === selectedPinId,
		);
		this.selectedPrimaryPinId = selectedPinId;
		this.selectedAdjacentPin = null;
		this.selectedAdjacentPinId = null;
		this.instruments = this.getInstruments(this.selectedPrimaryPin);
		this.selectedInstrument = null;
	}

	onSelectAdjacentSearchItem(selectedPinId: string) {
		this.selectedAdjacentPin = this.pins?.find(
			(pin) => pin.pin === selectedPinId,
		);
		this.selectedAdjacentPinId = selectedPinId;
		this.selectedPrimaryPin = null;
		this.selectedPrimaryPinId = null;
		this.instruments = this.getInstruments(this.selectedAdjacentPin);
		this.selectedInstrument = null;
	}

	showAdjacent() {
		this.showAdjacentPins = !this.showAdjacentPins;

		if (!this.showAdjacentPins) {
			if (this.primaryPinList.length) {
				this.selectedPrimaryPinId = this.primaryPinList[0].value;
				this.selectedPrimaryPin = this.pins?.find(
					(pin) => pin.pin === this.selectedPrimaryPinId,
				);
				this.instruments = this.getInstruments(this.selectedPrimaryPin);
				this.selectedInstrument = null;
			}
			this.selectedAdjacentPin = null;
			this.selectedAdjacentPinId = null;
		}
	}

	instrumentId(index: number, item: ParcelInstrument) {
		return item.reg_number;
	}

	closeModal() {
		this.dialogRef.close();
	}
}
